module.exports = __webpack_public_path__ + "img/cyber-attack.6182554b.png";